import Lottie from "lottie-react-web";
import React, { useEffect } from "react";
import lottieLoading from "assets/lotties/92541-loading.json";
import { Box, Text, Flex } from "@chakra-ui/react";
import create from "zustand";
import { useWindowSize } from "infra/helpers/window";

export const GlobalLoadingContext = React.createContext({
  isLoading: false,
});

export const useLoadingStore = create<{
  isLoading: boolean;
  message?: string;
  update: (v: boolean, message?: string) => any;
}>((set) => ({
  isLoading: false,
  message: undefined,
  update: (isLoading: boolean, message?: string) =>
    set(() => ({ isLoading, message })),
}));

export const useLoading = (state: boolean, message?: string) => {
  const { update } = useLoadingStore();

  useEffect(() => {
    update(state, message);
  }, [message, state, update]);

  return { update };
};

function GlobalLoading() {
  const { isLoading, message } = useLoadingStore();

  const windowSize = useWindowSize();

  const isMobile = windowSize.width <= 992;

  if (!isLoading) {
    return null;
  }

  return (
    <Flex
      position="fixed"
      left={0}
      right={0}
      top={0}
      bottom={0}
      zIndex={99999}
      bg="rgba(0,0,0,.4)"
      justifyContent="center"
      alignItems="center"
    >
      <Box bg="white" rounded={"lg"} px="48px">
        <Lottie
          width={isMobile ? "100px" : "200px"}
          options={{
            animationData: lottieLoading,
          }}
        />
        {message ? (
          <Text fontSize={18} textAlign="center" mt={-6} mb={4}>
            {message}
          </Text>
        ) : null}
      </Box>
    </Flex>
  );
}

export default GlobalLoading;
